document.addEventListener('DOMContentLoaded', function () {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.buttons = null;
      this.imageBoxes = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-right-box');
      this.imageBoxes = this.querySelectorAll('.yg-right-collection-image-box');
      this.buttons = this.querySelectorAll('.yg-collection-tab-item-button');
      if (this.tabs.length === 0 || this.items.length === 0) return;
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
        if (this.imageBoxes[i]) this.imageBoxes[i].classList.toggle('active', i === 0);
      });
      this.updateViewAllButton(0);
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      this.imageBoxes = this.querySelectorAll('.yg-right-collection-image-box');
      this.imageBoxes.forEach((img, j) => img.classList.toggle('active', index === j));
      this.updateViewAllButton(index);
    }

    updateViewAllButton(activeIndex) {
      if (!this.buttons || this.buttons.length === 0) return;

      this.buttons.forEach((btn, i) => {
        const isActive = i === activeIndex;
        btn.hidden = !isActive;
        btn.classList.toggle('active', isActive);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGKeyFeatured extends HTMLElement {
    connectedCallback() {
      // 等待字体及布局稳定后再初始化
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => requestAnimationFrame(() => this.init()));
      } else {
        requestAnimationFrame(() => requestAnimationFrame(() => this.init()));
      }
    }

    init() {
      const content = this.querySelector('.yg-featured-content');
      const toggleBtn = this.querySelector('.yg-toggle-btn');
      const btnText = this.querySelector('.yg-btn-text');

      const collapseLines = parseInt(this.dataset.collapseLines, 10);

      // collapseLines 为 0 表示展示全部，不启用折叠
      if (collapseLines === 0) {
        content.style.setProperty('-webkit-line-clamp', 'unset');
        content.style.removeProperty('overflow');
        return;
      }

      const lines = collapseLines || 6;

      // 先测量完整内容的高度
      content.style.setProperty('-webkit-line-clamp', 'unset');
      content.style.setProperty('overflow', 'visible');
      const fullHeight = content.scrollHeight;

      // 再设置 line-clamp 并测量
      content.style.setProperty('-webkit-line-clamp', String(lines));
      content.style.setProperty('overflow', 'hidden');
      
      // 强制重排
      content.offsetHeight;
      
      // 比较 scrollHeight 和 clientHeight，如果 scrollHeight 更大说明内容被截断
      const hasOverflow = content.scrollHeight > content.clientHeight + 5;

      if (hasOverflow) {
        // 需要折叠
        content.style.setProperty('-webkit-line-clamp', String(lines));

        toggleBtn.removeAttribute('hidden');

        toggleBtn.addEventListener('click', () => {
          if (toggleBtn.classList.contains('active')) {
            toggleBtn.classList.remove('active');
            content.style.setProperty('-webkit-line-clamp', String(lines));
            btnText.innerText = 'See More';
          } else {
            toggleBtn.classList.add('active');
            content.style.setProperty('-webkit-line-clamp', 'unset');
            btnText.innerText = 'See Less';
          }
        });
      } else {
        // 内容不足设定行数，完全展开
        content.style.setProperty('-webkit-line-clamp', 'unset');
      }
    }
  }

  if (!window.customElements.get('yg-key-featured')) {
    window.customElements.define('yg-key-featured', YGKeyFeatured);
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  class YGQuickBuyButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.finishLoading = this.finishLoading.bind(this);
    }

    connectedCallback() {
      const label = this.querySelector('span');
      label?.classList.add('yg-quick-buy-button__label');

      if (!this.querySelector('.button__loader')) {
        this.insertAdjacentHTML('beforeend', `
          <span class="button__loader" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
          </span>
        `);
      }

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.finishLoading();
    }

    handleClick() {
      if (this.getAttribute('aria-disabled') === 'true' || this.getAttribute('aria-busy') === 'true') return;

      const productCard = this.closest('product-card');
      const quickBuyButton = productCard?.querySelector('.product-card__quick-buy button:not([disabled])');

      if (!quickBuyButton) return;

      this.startLoading();

      const signal = this.loadingAbortController.signal;
      const quickBuyDrawerId = quickBuyButton.getAttribute('aria-controls');

      if (quickBuyButton.type === 'submit') {
        productCard.addEventListener('variant:add', this.finishLoading, { once: true, signal });
        productCard.addEventListener('cart:error', this.finishLoading, { once: true, signal });
      } else if (quickBuyDrawerId) {
        document.getElementById(quickBuyDrawerId)?.addEventListener('dialog:after-show', this.finishLoading, { once: true, signal });
      }

      quickBuyButton.click();
    }

    startLoading() {
      this.loadingAbortController?.abort();
      this.loadingAbortController = new AbortController();
      this.setAttribute('aria-busy', 'true');
      this.loadingTimeout = window.setTimeout(this.finishLoading, 10000);
    }

    finishLoading() {
      this.removeAttribute('aria-busy');
      window.clearTimeout(this.loadingTimeout);
      this.loadingAbortController?.abort();
      this.loadingAbortController = null;
    }
  }

  if (!window.customElements.get('yg-quick-buy-button')) {
    window.customElements.define('yg-quick-buy-button', YGQuickBuyButton);
  }

  class YGVariantInfoPicker extends HTMLElement {
    constructor() {
      super();
      this.listContainer = null;
      this.seeMoreBtn = null;
      this.maxVisibleItems = 3;
      this.observer = null;
      this.init();
    }
  
    init() {
      this.listContainer = this.querySelector('.yg-variant-info-list');
      this.seeMoreBtn = this.querySelector('.yg-variant-info-list__see-more');
      if (!this.listContainer || !this.seeMoreBtn) return;
  
      this.checkItemCount();
      this.seeMoreBtn.addEventListener('click', () => this.toggleExpanded());
      
      // 监听列表 DOM 变化（变体切换时重新检查）
      this.observer = new MutationObserver(() => {
        this.checkItemCount();
      });
  
      this.observer.observe(this.listContainer, {
        childList: true,
        subtree: true
      });
    }
  
    checkItemCount() {
      const items = this.listContainer.querySelectorAll('.yg-variant-info-wrapper');
      const itemCount = items.length;
  
      if (itemCount > this.maxVisibleItems) {
        this.seeMoreBtn.style.display = 'flex';
        this.listContainer.classList.add('is-collapsed');
        this.seeMoreBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.seeMoreBtn.style.display = 'none';
        this.listContainer.classList.remove('is-collapsed');
      }
    }
  
    toggleExpanded() {
      const isExpanded = this.seeMoreBtn.getAttribute('aria-expanded') === 'true';
  
      if (isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  
    expand() {
      this.listContainer.classList.remove('is-collapsed');
      this.seeMoreBtn.setAttribute('aria-expanded', 'true');
      const textSpan = this.seeMoreBtn.querySelector('.yg-variant-info-list__see-more-text');
      if (textSpan) textSpan.textContent = 'See Less';
    }
  
    collapse() {
      this.listContainer.classList.add('is-collapsed');
      this.seeMoreBtn.setAttribute('aria-expanded', 'false');
      const textSpan = this.seeMoreBtn.querySelector('.yg-variant-info-list__see-more-text');
      if (textSpan) textSpan.textContent = 'See More';
    }
  
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  
  if (!window.customElements.get('yg-variant-info-picker')) {
    window.customElements.define('yg-variant-info-picker', YGVariantInfoPicker);
  }

  class YGProductGalleryControls extends HTMLElement {
    constructor() {
      super();
      this.galleryId = null;
      this.mediaCarousel = null;
      this.thumbnailList = null;
      this.buttons = [];
      this.observer = null;
      this.init();
    }

    init() {
      this.galleryId = this.dataset.galleryId;
      if (!this.galleryId) return;

      this.mediaCarousel = document.getElementById(this.galleryId);
      if (!this.mediaCarousel) return;

      this.thumbnailList = this.mediaCarousel.closest('product-gallery')?.querySelector('.product-gallery__thumbnail-list');
      
      this.buttons = Array.from(this.querySelectorAll('[data-control-type]'));
      this.buttons.forEach(btn => {
        btn.addEventListener('click', (e) => this.handleButtonClick(e));
      });

      this.updateButtonStates();
      
      this.observer = new MutationObserver(() => this.updateButtonStates());
      const productGallery = this.mediaCarousel.closest('product-gallery');
      if (productGallery) {
        this.observer.observe(productGallery, {
          attributes: true,
          subtree: true,
          attributeFilter: ['aria-current']
        });
      }
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const controlType = button.dataset.controlType;

      if (button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const currentIndex = this.getCurrentMediaIndex();
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;

      if (controlType === 'up' || controlType === 'left') {
        nextIndex = Math.max(0, currentIndex - 1);
      } else if (controlType === 'down' || controlType === 'right') {
        nextIndex = Math.min(this.getVisibleMediaCount() - 1, currentIndex + 1);
      }

      this.scrollToMedia(nextIndex);
    }

    getCurrentMediaIndex() {
      const productGallery = this.mediaCarousel.closest('product-gallery');
      if (!productGallery) return -1;

      const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
      let visibleIndex = 0;

      for (let i = 0; i < thumbnails.length; i++) {
        if (thumbnails[i].hidden) continue;
        
        if (thumbnails[i].getAttribute('aria-current') === 'true') {
          return visibleIndex;
        }
        visibleIndex++;
      }

      return 0;
    }

    getVisibleMediaCount() {
      const productGallery = this.mediaCarousel.closest('product-gallery');
      if (!productGallery) return 0;

      const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
      let count = 0;

      thumbnails.forEach(thumb => {
        if (!thumb.hidden) count++;
      });

      return count;
    }

    scrollToMedia(visibleIndex) {
      const productGallery = this.mediaCarousel.closest('product-gallery');
      if (!productGallery) return;

      const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
      let currentVisibleIndex = 0;

      for (let i = 0; i < thumbnails.length; i++) {
        if (thumbnails[i].hidden) continue;

        if (currentVisibleIndex === visibleIndex) {
          thumbnails[i].click();
          break;
        }

        currentVisibleIndex++;
      }
    }

    updateButtonStates() {
      const currentIndex = this.getCurrentMediaIndex();
      const visibleCount = this.getVisibleMediaCount();

      this.buttons.forEach(btn => {
        const controlType = btn.dataset.controlType;

        if (controlType === 'up' || controlType === 'left') {
          btn.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');
        } else if (controlType === 'down' || controlType === 'right') {
          btn.setAttribute('aria-disabled', currentIndex === visibleCount - 1 ? 'true' : 'false');
        }
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.buttons.forEach(btn => {
        btn.removeEventListener('click', (e) => this.handleButtonClick(e));
      });
    }
  }

  if (!window.customElements.get('yg-product-gallery-controls')) {
    window.customElements.define('yg-product-gallery-controls', YGProductGalleryControls);
  }
  
  class YGGalleryBadge extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.badgeContainer = null;
      this.init();
    }

    init() {
      const gallery = this.closest('product-gallery');
      if (!gallery) return;

      const productForm = gallery.getAttribute('form');
      this.form = productForm ? document.getElementById(productForm) : null;
      this.badgeContainer = this;

      if (this.form) {
        this.form.addEventListener('variant:change', (e) => this.handleVariantChange(e));
      }
    }

    async handleVariantChange(event) {
      const variant = event.detail.variant;
      if (!variant) return;

      try {
        const response = await fetch(`${window.location.pathname}?section_id=${this.form.dataset.sectionId}&variant=${variant.id}`, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBadges = doc.querySelector('[data-badge-container]');

          if (newBadges) {
            this.badgeContainer.innerHTML = newBadges.innerHTML;
          }
        }
      } catch (error) {
        console.error('Failed to update badges:', error);
      }
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('variant:change', (e) => this.handleVariantChange(e));
      }
    }
  }

  if (!window.customElements.get('yg-gallery-badge')) {
    window.customElements.define('yg-gallery-badge', YGGalleryBadge);
  }

  // Delayed loading for pop-convert-app (third-party plugin)
  const DELAY_POP_CONVERT_MS = 10000;
  const POP_CONVERT_ID = 'pop-convert-app';

  function hidePopConvertApp() {
    const $app = document.getElementById(POP_CONVERT_ID);
    if (!$app || $app.dataset.ygDelayed === 'true') return false;
    $app.dataset.ygDelayed = 'true';
    $app.style.setProperty('display', 'none', 'important');
    setTimeout(() => {
      $app.style.setProperty('display', 'block', 'important');
    }, DELAY_POP_CONVERT_MS);
    return true;
  }

  // Try immediately; if not yet injected, poll until it appears (max 30s)
  if (!hidePopConvertApp()) {
    const pollStartTime = Date.now();
    const MAX_POLL_DURATION = 30000;
    const popConvertTimer = setInterval(() => {
      if (hidePopConvertApp() || Date.now() - pollStartTime > MAX_POLL_DURATION) {
        clearInterval(popConvertTimer);
      }
    }, 500);
  }
});
